/**
 * Сколько ехать до машины, с учётом пробок.
 *
 * Только по нажатию, не само. На то две причины, и обе весомые: каждый расчёт
 * тратит бесплатный лимит у Google, а местоположение человека уходит третьей
 * стороне — молча такое делать нельзя.
 *
 * Считает сервер: ключ живёт там, в браузер он не попадает. Отсюда уходит
 * только точка, где человек находится, и она нигде не сохраняется.
 */

import { useState } from 'react'

import { ApiError } from './api'
import { duration } from './format'
import { whereAmI } from './geolocate'
import { dict, type Lang } from './i18n'

type Props = {
  lang: Lang
  /** Спросить у сервера время в пути от этой точки. Секунды или отказ. */
  ask: (from: { latitude: number; longitude: number }) => Promise<{ seconds: number }>
}

export function EtaButton({ lang, ask }: Props) {
  const t = dict(lang)
  const [busy, setBusy] = useState(false)
  const [seconds, setSeconds] = useState<number | null>(null)
  const [error, setError] = useState('')

  async function count() {
    setBusy(true)
    setError('')
    setSeconds(null)
    try {
      const where = await whereAmI()
      if (!where) {
        setError(t.etaNoLocation)
        return
      }
      setSeconds((await ask(where)).seconds)
    } catch (caught) {
      setError(caught instanceof ApiError && caught.message ? caught.message : t.networkError)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <button className="act ghost" disabled={busy} onClick={() => void count()}>
        {busy ? t.working : t.etaAction}
      </button>
      {seconds !== null && (
        <div className="kv">
          <span>{t.etaWithTraffic}</span>
          <b>{duration(seconds * 1000, lang, t)}</b>
        </div>
      )}
      {error && (
        <div className="login-error" role="alert">
          {error}
        </div>
      )}
    </>
  )
}
